var AdminetIntegrationModal = require("src/client-ts/containers/Integrations/adminet/modal/ImportCostCalculationToAdminetModal");

exports.integrationModal =
  AdminetIntegrationModal.ImportCostCalculationToAdminetModal;
